import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const slides = [
    '/banner/facade-cladding.jpg',
    '/banner/curtain-wall.jpg',
    '/banner/glass-towers.jpg',
    '/banner/glazed-facade.jpg',
];

const stats = [
    { value: '14+', label: 'Projects' },
    { value: '4000', label: 'Sq.ft daily capacity' },
    { value: '2', label: 'Glazing lines' },
];

const imageUrl = (path) => `${process.env.PUBLIC_URL}${path}`;

const useCount = (target) => {
    const [value, setValue] = useState(0);

    useEffect(() => {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced) {
            setValue(target);
            return undefined;
        }

        const start = performance.now();
        const duration = 1100;
        let frame = 0;

        const tick = (now) => {
            const progress = Math.min(1, (now - start) / duration);
            const eased = 1 - (1 - progress) ** 3;
            setValue(Math.round(target * eased));
            if (progress < 1) frame = window.requestAnimationFrame(tick);
        };

        frame = window.requestAnimationFrame(tick);
        return () => window.cancelAnimationFrame(frame);
    }, [target]);

    return value;
};

const Stat = ({ value, label }) => {
    const numeric = Number.parseInt(value, 10);
    const suffix = value.slice(String(numeric).length);
    const shown = useCount(numeric);

    return (
        <div>
            <strong>{shown}{suffix}</strong>
            <span>{label}</span>
        </div>
    );
};

const Banner = () => {
    const [active, setActive] = useState(0);

    useEffect(() => {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced) return undefined;
        const timer = window.setInterval(() => {
            setActive((current) => (current + 1) % slides.length);
        }, 5500);
        return () => window.clearInterval(timer);
    }, []);

    return (
        <section className="facade-hero" id="home">
            {slides.map((slide, index) => (
                <img
                    key={slide}
                    src={imageUrl(slide)}
                    alt=""
                    className={`facade-hero-slide ${index === active ? 'is-active' : ''}`}
                />
            ))}
            <div className="facade-hero-shade" />
            <div className="container facade-hero-copy">
                <div className="row align-items-end g-4">
                    <div className="col-lg-7">
                        <p className="hero-kicker hero-enter">High-quality cladding and glazing</p>
                        <h1 className="hero-enter">Precision for every facade</h1>
                        <p className="hero-enter">Premium quality aluminium and UPVC work for facades, glazing, and modern buildings across Delhi NCR.</p>
                        <div className="hero-actions hero-enter">
                            <Link className="hero-btn is-solid" to="/about">Explore more</Link>
                            <Link className="hero-btn" to="/projects">View projects</Link>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="hero-stats hero-enter">
                            {stats.map((stat) => (
                                <Stat key={stat.label} value={stat.value} label={stat.label} />
                            ))}
                        </div>
                    </div>
                </div>
                <div className="hero-dots" role="tablist" aria-label="Featured projects">
                    {slides.map((slide, index) => (
                        <button
                            key={slide}
                            type="button"
                            className={index === active ? 'is-active' : ''}
                            aria-label={`Show slide ${index + 1}`}
                            onClick={() => setActive(index)}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Banner;
